export const LOGIN_URL = "https://18.228.239.219.nip.io";
export const DASHBOARD_URL = "error";

// export const LOGIN_URL = "http://localhost:3001";
// export const DASHBOARD_URL = "http://localhost:3005";
